import { useMutation } from '@tanstack/react-query';
import saveAs from 'file-saver';
import { downloadLogData } from './api';
import { getLogData } from './ModalTable/api';
import { Logs } from './ModalTable/LogType';

interface UseDownloadLogProperties {
  jobId?: number;
  onViewSuccess?: (logs: Logs, fileName: string) => void;
  startTime?: string;
}

export const useDownloadLog = ({
  jobId,
  startTime,
  onViewSuccess,
}: UseDownloadLogProperties) => {
  const { mutate: downloadLog, isPending: isDownloading } = useMutation({
    mutationFn: downloadLogData,
    onError: (error) => {
      console.error('Error downloading log:', error);
    },
    onSuccess: (response) => {
      const blob = new Blob([response.data], {
        type: response.contentType as string,
      });
      saveAs(blob, response.name);
    },
  });

  const { mutate: viewLog, isPending: isLoadingLog } = useMutation({
    mutationFn: getLogData,
    onError: (error) => {
      console.error('Error loading log:', error);
    },
    onSuccess: (logs) => {
      if (onViewSuccess && jobId) {
        const fileName = `Log Data - Job ${jobId}`;
        onViewSuccess(logs, fileName);
      }
    },
  });

  const handleDownloadLog = () => {
    if (jobId && startTime) {
      downloadLog({ jobId, startTime });
    }
  };

  const handleViewLog = () => {
    if (jobId && startTime) {
      viewLog({ jobId, startTime });
    }
  };

  return {
    handleDownloadLog,
    handleViewLog,
    isDownloading,
    isLoadingLog,
  };
};
